// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2zjGY","filesListContainer":"PosDisputesFiles_filesListContainer__2n_SA","filesButton":"PosDisputesFiles_filesButton__3Z4xy"};